// removed by extract-text-webpack-plugin
module.exports = {"blog_post":"src-templates----blog-post-module---blog_post---3dQhf"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/blog-post.module.css
// module id = 305
// module chunks = 107818501498521